import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import AdminEmergency from "@/pages/AdminEmergency";
import Dashboard from "@/pages/Dashboard";
import DataEntryForm from "@/pages/DataEntryForm";
import WorkOrders from "@/pages/WorkOrders";
import Mechanics from "@/pages/Mechanics";
import VehicleChronicle from "@/pages/VehicleChronicle";
import Vehicles from "@/pages/Vehicles";
import VehicleProfile from "@/pages/VehicleProfile";
import Bonuses from "@/pages/Bonuses";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Staff from "@/pages/Staff";
import Comparison from "@/pages/Comparison";
import Profile from "@/pages/Profile";
import Personnel from "@/pages/Personnel";
import Drivers from "@/pages/Drivers";
import DriverProfile from "@/pages/DriverProfile";
import Accidents from "@/pages/Accidents";
import ShiftSchedule from "@/pages/ShiftSchedule";
import DriverDiscipline from "@/pages/DriverDiscipline";
import FieldSupervisors from "@/pages/FieldSupervisors";
import RepeatFaults from "@/pages/RepeatFaults";
import Kasa from "@/pages/Kasa";
import Notlar from "@/pages/Notlar";
import FieldTasks from "@/pages/FieldTasks";
import ExternalServices from "@/pages/ExternalServices";
import { Toaster } from "@/components/ui/sonner";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  // Update 29.8 — Tüm roller Kontrol Paneli'nde açılır.
  return <Navigate to="/dashboard" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin-emergency" element={<AdminEmergency />} />

            {/* ─── Herkes (3 rol): Kontrol Paneli, İş Emirleri (viewer read-only),
                 Tekrar Arızalar, Filo, Kronik, Karşılaştırma, Vardiya, Ustalar,
                 Disiplin, Kaza Raporları, Kasa, Notlar, Profilim, Araç profili ─── */}
            <Route
              element={
                <ProtectedRoute roles={["admin", "data_entry", "viewer"]}>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/is-emirleri" element={<WorkOrders />} />
              <Route path="/tekrar-arizalar" element={<RepeatFaults />} />
              <Route path="/araclar" element={<Vehicles />} />
              <Route path="/arac/:code" element={<VehicleProfile />} />
              <Route path="/kronik" element={<VehicleChronicle />} />
              <Route path="/karsilastirma" element={<Comparison />} />
              <Route path="/vardiya" element={<ShiftSchedule />} />
              <Route path="/ustalar" element={<Mechanics />} />
              <Route path="/sofor-disiplin" element={<DriverDiscipline />} />
              <Route path="/kaza-raporlari" element={<Accidents />} />
              <Route path="/kasa" element={<Kasa />} />
              <Route path="/notlar" element={<Notlar />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/dis-servis" element={<ExternalServices />} />
              <Route path="/personel-kadrosu" element={<Navigate to="/soforler" replace />} />
            </Route>

            {/* ─── admin + data_entry: Yeni İş Emri, Personel, Günlük Görevler ─── */}
            <Route
              element={
                <ProtectedRoute roles={["admin", "data_entry"]}>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/veri-giris" element={<DataEntryForm />} />
              <Route path="/yeni-is-emri" element={<DataEntryForm />} />
              <Route path="/is-emirleri/:id/duzenle" element={<DataEntryForm />} />
              <Route path="/soforler" element={<Drivers />} />
              <Route path="/soforler/:id" element={<DriverProfile />} />
              <Route path="/saha-gorevler" element={<FieldTasks />} />
            </Route>

            {/* ─── admin only: Users, E-posta, Ayarlar, Prim & Karne, Saha Primi ─── */}
            <Route
              element={
                <ProtectedRoute roles={["admin"]}>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/personel" element={<Staff />} />
              <Route path="/kullanicilar" element={<Users />} />
              <Route path="/ayarlar" element={<Settings />} />
              <Route path="/saha-sorumlulari" element={<FieldSupervisors />} />
              <Route path="/prim-hakedis" element={<Bonuses />} />
            </Route>

            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
